import ArmazemModuleService from '@/services/ArmazemModuleService';
import RastreabilidadeProdutoService from '@/services/RastreabilidadeProdutoService';
import RastreabilidadeExportacaoService from '@/services/RastreabilidadeExportacaoService';
import RastreabilidadeTransacaoArmazemService from '@/services/RastreabilidadeTransacaoArmazemService';

export const fetchSilo = async ({ state, commit }) => {
    try {
        const response = await ArmazemModuleService.getAllWarehouses(state.typeList);
        commit('SET_SILOS', response.data);
    } catch (error) {
        throw error;
    }
};

export const fetchProducts = async ({ commit }) => {
    try {
        const response = await RastreabilidadeProdutoService.getProducts();
        commit('SET_PRODUCTS', response.data);
    } catch (error) {
        throw error;
    }
};

export const createIndividualExportRecord = async ({ state, commit }, formData) => {
    try {
        const response = await RastreabilidadeExportacaoService.createIndividualExportRecord(state.individualExport);
        return response;
    } catch (error) {
        throw error;
    }
};

export const fetchIndividualExportRecordById = async (_, id) => {
    try {
         const response = await RastreabilidadeExportacaoService.fetchIndividualExportRecordById(id);
         return response.data;
    } catch (error) {
        throw error;
    }
};

export const fetchOperations = async ({ state, commit }) => {
    try {
        const page = state.filter.page ? state.filter.page - 1 : 0;
        const size = state.filter.size ?? 10;
        const body = {
            filtroTexto: state.filter.contract_number ?? null,
            codigoStatus: state.filter.status[0]?.toUpperCase() ?? null,
            dataInicio: state.filter.initialDate ?? null,
            dataFim: state.filter.endDate ?? null,
            idArmazem: 0,
            idArmazemOrigem: state.filter.origin ?? 0,
            idArmazemDestino: state.filter.destination ?? 0,
            idTipoTransacao: state.filter.type
        };
        const response = await RastreabilidadeTransacaoArmazemService.getOperationsByWarehouseFilter(
            body,
            page,
            size
        );
        commit('SET_OPERATION_LIST', response.data);
    } catch (error) {
        throw error;
    }
};
